import { loadScript } from 'utils/loadScript'
import { REACT_APP_GOOGLE_API_KEY, REACT_APP_GOOGLE_CLIENT_ID } from 'env'

export const loadGoogleApiScripts = () => {
  const gapiPromise = new Promise<void>((res, rej) => {
    loadScript('https://apis.google.com/js/api.js', res, () => rej(new Error('Failed to load Google API script')))
  })

  const gisPromise = new Promise<void>((res, rej) => {
    loadScript('https://accounts.google.com/gsi/client', res, () =>
      rej(new Error('Failed to load Google Identity Services')),
    )
  })

  return Promise.all([gapiPromise, gisPromise])
}

export const initializeDriveTokenClient = (callback: (tokenResponse: google.accounts.oauth2.TokenResponse) => void) => {
  const scopes = [
    'https://www.googleapis.com/auth/userinfo.email', // See your primary Google Account email address
    'https://www.googleapis.com/auth/userinfo.profile', // See your personal info, including any personal info you've made publicly available
    'https://www.googleapis.com/auth/drive.readonly', // Files
  ].join(' ')

  return google.accounts.oauth2.initTokenClient({
    client_id: REACT_APP_GOOGLE_CLIENT_ID,
    scope: scopes,
    callback: callback,
  })
}
export const initializeContactsTokenClient = (
  callback: (tokenResponse: google.accounts.oauth2.TokenResponse) => void,
) => {
  // List of scopes: https://developers.google.com/identity/protocols/oauth2/scopes
  const scopes = [
    'https://www.googleapis.com/auth/contacts.readonly', // See and download your contacts
    'https://www.googleapis.com/auth/contacts.other.readonly', // See and download contact info automatically saved in your "Other contacts"
  ].join(' ')

  // returns tokenClient
  return google.accounts.oauth2.initTokenClient({
    // In your API Console project, add a JS origin that corresponds to the domain where the script will run.
    client_id: REACT_APP_GOOGLE_CLIENT_ID,
    scope: scopes,
    callback: callback,
  })
}

export const initializeGapiClient = () =>
  new Promise<void>((res) => {
    gapi.load('client', async () => {
      await gapi.client.init({
        apiKey: REACT_APP_GOOGLE_API_KEY,
        discoveryDocs: [
          'https://www.googleapis.com/discovery/v1/apis/drive/v3/rest',
          'https://people.googleapis.com/$discovery/rest?version=v1',
        ],
      })
      res()
    })
  })

export const initializePickerApi = () =>
  new Promise<void>((res) => {
    gapi.load('picker', () => {
      res()
    })
  })
